import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { BotService } from '../services/bot.service';
import { map, catchError, switchMap, tap } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { UserInterface } from '../../models/user.interface';
import { GlobalObservableService } from '../services/global-observable.service';
import { LoggerService } from '../services/logger.service';

@Injectable({
  providedIn: 'root',
})
export class BotGuard implements CanActivate {
  constructor(
    private router: Router,
    private botService: BotService,
    private userService: UserService,
    private globalObservable: GlobalObservableService,
    private logger: LoggerService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const action = next.paramMap.get('action');
    if (action) {
      try {
        const decodedAction = atob(action);
        if (decodedAction === 'REFRESH_USER') {
          localStorage.removeItem('user');
          localStorage.setItem('show_subscription_success_modal', 'true');
        }
      } catch (e) {
        // Ignorar Base64 inválido - manejo seguro de errores de decodificación
        this.logger.warn('Invalid Base64 action parameter', action);
      }
      this.router.navigate(['dashboard']);
      return false;
    }
    const localUser = this.userService.getUserLocalStorage();

    const user$: Observable<UserInterface> = localUser
      ? of(localUser)
      : this.userService.getUser().pipe(tap((value) => this.userService.setUser(value)));

    return user$.pipe(
      switchMap((user: UserInterface) =>
        this.botService.getBots().pipe(
          map((data: any) => {
            data.length > 0 ? this.botService.setHaveBots(true) : this.botService.setHaveBots(false);
            return data.length > 0 || !user.on_boarding
              ? true
              : this.router.createUrlTree(['/dashboard', 'new-bot']);
          })
        )
      ),
      catchError((error) => {
        if (error.status === 401) {
          localStorage.removeItem('user');
          this.logger.error('Error 401: No autorizado. Redirigiendo al login...');
          this.globalObservable.publish('logOut', {});
          this.router.navigate(['dashboard', 'login']);
          return of(false);
        }
        return of(false);
      })
    );
  }
}
